<div class="mobile-nav">
  <!-- User Info Section at Top -->
  <mat-tab-group [mat-stretch-tabs]="false" [selectedIndex]="selectedTabIndex()" mat-align-tabs="start">
    @if (sidebarService.isMobile()) {
      <mat-tab [label]="'navigation.title' | translate">
        <div class="user-section">
          <app-user></app-user>
        </div>

        <!-- Navigation Section -->
        <div class="nav-section">
          <div class="nav-items">
            @for (navItem of navItems; track navItem) {
              <a class="nav-item" [routerLink]="navItem.route" (isActiveChange)="closeSidebar()" routerLinkActive="active">
                {{ navItem.transKey | translate }}
              </a>
            }
          </div>
        </div>

        <!-- Settings Accordion -->
        <div class="settings-accordion-container">
          <mat-accordion class="version1">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ 'header.settings' | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- Theme Switch -->
              <div class="settings-section">
                <h3 class="section-title">{{ 'header.theme' | translate }}</h3>
                <div class="theme-buttons">
                  <button class="theme-btn" [class.active]="theme === 'light'" (click)="setTheme('light')">
                    {{ 'header.light' | translate }}
                  </button>
                  <button class="theme-btn" [class.active]="theme === 'dark'" (click)="setTheme('dark')">
                    {{ 'header.dark' | translate }}
                  </button>
                </div>
              </div>

              <!-- Language Switch -->
              <div class="settings-section">
                <h3 class="section-title">{{ 'header.language' | translate }}</h3>
                <div class="language-buttons">
                  <button class="lang-btn" [class.active]="language === 'en'" (click)="changeLang('en')">English</button>
                  <button class="lang-btn" [class.active]="language === 'de'" (click)="changeLang('de')">Deutsch</button>
                </div>
              </div>

              <!-- Settings Options -->
              <div class="settings-section">
                @if ((userRole$ | async) !== USER_ROLES.ONLINE_SUPPORT) {
                  <button class="settings-item" (click)="openApplicationFilterDialog()">
                    {{ 'header.applicationFilter' | translate }}
                  </button>
                  <button class="settings-item" (click)="openTimesheetSettingsDialog()">
                    {{ 'header.timesheetSettings' | translate }}
                  </button>
                  <button class="settings-item" (click)="navigateToPersonalInformationPage()">
                    {{ 'header.personalInformation' | translate }}
                  </button>
                }

                @if (
                  (userRole$ | async) === USER_ROLES.TECHNISCHER_CONTROLLER ||
                  (userRole$ | async) === USER_ROLES.BUDGETVERANTWORTLICHER ||
                  (userRole$ | async) === USER_ROLES.GRUPPENLEITER
                ) {
                  <button class="settings-item" (click)="openCreateNewsDialog()">{{ 'header.createNews' | translate }}</button>
                }

                <button class="settings-item" (click)="navigateToReleaseNotesPage()">
                  {{ 'header.releaseNotes' | translate }}
                </button>

                @if ((userRole$ | async) !== USER_ROLES.ONLINE_SUPPORT) {
                  <div class="impersonation-section">
                    <span class="impersonation-title">{{ 'header.userSettings.impersonation.impersonation' | translate }}</span>
                    @if (!isImpersonating()) {
                      <button class="settings-item submenu-item" (click)="openSelectImpersonationDialog()">
                        {{ 'header.userSettings.impersonation.impersonate' | translate }}
                      </button>
                      <button class="settings-item submenu-item" (click)="openEditImpersonationDialog()">
                        {{ 'header.userSettings.impersonation.editImpersonation' | translate }}
                      </button>
                    } @else {
                      <button class="settings-item submenu-item" (click)="stopImpersonation()">
                        {{ 'header.userSettings.impersonation.stopImpersonation' | translate }}
                      </button>
                    }
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <!-- Reporting Links at Bottom -->
        <div class="nav-links">
          <a class="nav-link" [href]="serviceDeskLink" [matTooltip]="'default.support' | translate" target="_blank">
            Support
            <span class="icon-Link-extern"></span>
          </a>
          <a class="nav-link" [href]="reportingLink" target="_blank">
            {{ 'navigation.reporting' | translate }}
            <span class="icon-Link-extern"></span>
          </a>
        </div>
      </mat-tab>
    }

    <mat-tab [label]="'navigation.news' | translate">
      <app-news></app-news>
    </mat-tab>
    <mat-tab [label]="'navigation.notifications' | translate">
      <app-notifications />
    </mat-tab>
  </mat-tab-group>
</div>
